export default __webpack_public_path__ + "static/media/online.96639284.svg";